import { create } from 'zustand';

const useTasksStore = create((set, get) => ({
  // State
  tasks: [],
  isLoading: false,
  error: null,
  lastFetched: null,

  // Actions
  setTasks: (tasks) => set({ tasks, lastFetched: Date.now() }),
  
  // Initialize tasks from user's initial data (when app launches)
  initializeFromUserData: (userInitData) => {
    if (userInitData && Array.isArray(userInitData)) {
      set({ 
        tasks: userInitData,
        isLoading: false,
        lastFetched: Date.now()
      });
      return true;
    }
    return false;
  },
  
  setLoading: (isLoading) => set({ isLoading }),
  
  setError: (error) => set({ error }),
  
  addTask: (newTask) => set((state) => ({
    tasks: [...state.tasks, newTask]
  })),
  
  updateTask: (taskId, updates) => set((state) => ({
    tasks: state.tasks.map(task => 
      task.id === taskId ? { ...task, ...updates } : task
    )
  })),
  
  toggleTask: (taskId) => set((state) => ({
    tasks: state.tasks.map(task => 
      task.id === taskId ? { 
        ...task, 
        estado: task.estado === 'completado' ? 'pendiente' : 'completado' 
      } : task
    )
  })),
  
  deleteTask: (taskId) => set((state) => ({
    tasks: state.tasks.filter(task => task.id !== taskId)
  })),
  
  deleteCompletedTasks: () => set((state) => ({
    tasks: state.tasks.filter(task => task.estado !== 'completado')
  })),
  
  clearTasks: () => set({ tasks: [], lastFetched: null }),
  
  // Reset the entire store (used on logout)
  resetStore: () => {
    set({ 
      tasks: [], 
      isLoading: false, 
      error: null, 
      lastFetched: null 
    });
    console.log('[TasksStore] Store reset on logout');
  },
  
  // Check if tasks need to be fetched (empty or older than 5 minutes)
  shouldFetch: () => {
    const state = get();
    if (state.tasks.length === 0) return true;
    if (!state.lastFetched) return true;
    
    const fiveMinutes = 5 * 60 * 1000;
    return (Date.now() - state.lastFetched) > fiveMinutes;
  },
  
  // Get tasks for a specific user
  getTasksForUser: (userId) => {
    const state = get();
    return state.tasks.filter(task => task.usuario_id === String(userId)); // Use usuario_id instead of usuarioId
  }
}));

export default useTasksStore;
